module.exports = __webpack_public_path__ + "img/jaf.66b92bcc.png";